import { useEffect, useRef } from 'react'

import { useGretaAIChatFocus } from '../../useGretaAIChatFocus'
import { useGretaAIChatPanelState } from '../../useGretaAIChatPanelState'

export function useGretaAIChatSessionPanel() {
  const launcherRef = useRef(null)
  const panelRef = useRef(null)
  const chatListScrollTopRef = useRef(0)
  const chatListSeenChatIdRef = useRef(null)

  const {
    activeChatId,
    chatListWidth,
    closeChatList,
    handleMinimize,
    handleOpen,
    handleToggleMode,
    hoverChatList,
    isChatListColumnOpen,
    isChatListHovered,
    isChatListOrderFrozen,
    isChatListPinned,
    isMinimized,
    isOpen,
    mode,
    openChat,
    openNewChat,
    openProjectsPage,
    pinChatList,
    setActiveChatId,
    setChatListWidth,
    setIsChatListOrderFrozen,
    toggleChatListColumn,
    unhoverChatList,
    view,
  } = useGretaAIChatPanelState()

  const activeChatIdRef = useRef(activeChatId)

  useEffect(() => {
    activeChatIdRef.current = activeChatId
  }, [activeChatId])

  useGretaAIChatFocus({
    isMinimized,
    isOpen,
    launcherRef,
    panelRef,
  })

  return {
    activeChatId,
    activeChatIdRef,
    handleOpen,
    isMinimized,
    isOpen,
    launcherRef,
    openChat,
    openNewChat,
    panel: {
      activeChatId,
      chatListScrollTopRef,
      chatListSeenChatIdRef,
      chatListWidth,
      isChatListColumnOpen,
      isChatListHovered,
      isChatListOrderFrozen,
      isChatListPinned,
      isMinimized,
      isOpen,
      mode,
      panelRef,
      view,
    },
    panelActions: {
      setActiveChatId,
      onChatListResize: setChatListWidth,
      onCloseChatList: closeChatList,
      onHoverChatList: hoverChatList,
      onMinimize: handleMinimize,
      onOpenProjectsPage: openProjectsPage,
      onPinChatList: pinChatList,
      onRowMenuOpenChange: setIsChatListOrderFrozen,
      onToggleChatListColumn: toggleChatListColumn,
      onToggleMode: handleToggleMode,
      onUnhoverChatList: unhoverChatList,
    },
    panelRef,
    setActiveChatId,
    view,
  }
}
